import { css, styled } from '@mui/material';

import { modalBodyClasses } from './theme';

import type { ModalBodyContentProps } from './types';

const ModalBodyContent = (props: ModalBodyContentProps) => {
  const { children, ...others } = props;
  return <ModalBodyContentRoot {...others}>{children}</ModalBodyContentRoot>;
};

ModalBodyContent.displayName = 'ModalBodyContent';

export default ModalBodyContent;

const ModalBodyContentRoot = styled('div', {
  name: 'ModalBodyContent',
  slot: 'Root',
  target: modalBodyClasses.content,
})(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  `,
);
